<template>
  <div class="child-wrapper">
    <section id="category-overall">
      <article>
        <div class="row clearfix">
          <h1>
            Overall Category Highlights
            <!-- <a href="#" data-table="category-overall-highlights-table" class="infotoggle inline tooltipstered">Click for moreinfo</a> -->
          </h1>
          <div class="sixcol">
            <p>This section presents an analysis for each of the 12 event categories, as defined in
              <router-link style="color: #fff;" :to="{name:'Appendix'}">the Appendix</router-link>. All categories experienced a decline in revenue and attendance in 2020, driven by COVID-19 restrictions and limited touring activity.</p>
            <ul>
              <li><strong>Contemporary Music </strong>continues to be the top live performance category.<strong> Contemporary Music </strong>generated approximately 43% of revenue and 35% of attendance of the overall live performance market in 2019. The category generated more than 51% of revenue and 37% of attendance in 2020.</li>
              <li><strong>Circus and Physical Theatre</strong>, <strong>Theatre</strong> and <strong>Festivals (Contemporary Music)</strong> experienced a significant increase in revenue and attendance in 2019, followed by a significant decline in revenue and attendance in 2020.</li>
            </ul>
          </div>
          <div class="sixcol last">
            <ul>
              <li><strong>Classical Music </strong>and<strong> Ballet and Dance </strong>experienced a moderate increase in revenue and attendance in 2019, followed by a significant decline in revenue and attendance in 2020.</li>
              <li><strong>Children's/Family</strong>,<strong> Contemporary Music</strong>,<strong> Festivals (Multi-Category)</strong>,<strong> Comedy</strong>,<strong> Musical Theatre</strong>, and<strong> Opera </strong>experienced a decline in revenue and attendance in 2019, followed by a significant decline in 2020.</li>
              <li><strong>Special Events</strong> experienced a moderate decline in revenue despite the highest y-o-y growth in attendance in 2019, and a significant decline in revenue and attendance in 2020.</li>
            </ul>
          </div>
        </div>
      </article>

      <figure class="chart">
        <ul class="switches" style="position: relative;z-index: 3;">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="row clearfix">
          <div class="row callouts clearfix" v-if="activeReport">
            <aside id="category-overall-toprev" class="sixcol">
              <h3>Highest Revenue</h3>
              <h2 style="visibility: visible;">
                $<ICountUp :endVal="activeReport.highestRevenue.value" :options="{decimalPlaces: 2}"/>m
              </h2>
              <h3>{{ activeReport.highestRevenue.cat }}</h3>
            </aside>

            <aside id="category-overall-topatt" class="sixcol last">
              <h3>Highest Attendance</h3>
              <h2 style="visibility: visible;">
                <ICountUp :endVal="activeReport.highestAttendance.value" :options="{decimalPlaces: 2}"/>m
              </h2>
              <h3>{{ activeReport.highestAttendance.cat }}</h3>
            </aside>
          </div>
          <div class="callouts clearfix">
            <aside id="category-overall-revchange" class="sixcol">
              <h3>Biggest Revenue Change</h3>
              <h2 style="visibility: visible;">
                {{ activeReport.biggestRevenueChange.dir=='up' ? '↑' : '↓' }}
                <ICountUp :endVal="activeReport.biggestRevenueChange.value" :options="{decimalPlaces: 1}"/>%
              </h2>
              <h3>{{ activeReport.biggestRevenueChange.cat }}</h3>
            </aside>
            <aside id="category-overall-attchange" class="sixcol last">
              <h3>Biggest Attendance Change</h3>
              <h2 style="visibility: visible;">
                {{ activeReport.biggestAttendanceChange.dir=='up' ? '↑' : '↓' }}
                <ICountUp :endVal="activeReport.biggestAttendanceChange.value" :options="{decimalPlaces: 1}"/>%
              </h2>
              <h3>{{ activeReport.biggestAttendanceChange.cat }}</h3>
            </aside>
          </div>
        </div>
      </figure>

      <div class="fullbg">
        <p class="caption">Photo: <em>Summer of the Seventeenth Doll</em>, State Opera South Australia, Photo Credit: Soda Street Productions</p>
      </div>

      <figure id="category-overall-highlights-table" class="data">
        <div class="row clearfix">
          <h3>Top 5 Categories - Revenue and Attendance</h3>
          <a href="#" data-table="category-overall-highlights-table" class="closetable" title="Top Categories">Close
            Table</a>
          <table cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <th colspan="4">Revenue</th>
              <th colspan="4">Attendance</th>
            </tr>
            <tr>
              <th width="3%"></th>
              <th valign="top" width="25%">Category</th>
              <th valign="top" width="12%">Revenue</th>
              <th valign="top">Share of industry</th>
              <th width="3%"></th>
              <th valign="top" width="25%">Category</th>
              <th valign="top" width="12%">Attendance</th>
              <th valign="top">Share of industry</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>1</th>
              <td valign="bottom">Contemporary Music</td>
              <td valign="middle" class="number">$1,092,275,549</td>
              <td valign="middle" class="number">50.5%</td>

              <th>1</th>
              <td valign="bottom">Contemporary Music</td>
              <td valign="middle" class="number">10,088,329</td>
              <td valign="middle" class="number">38.4%</td>

            </tr>
            <tr>
              <th>2</th>
              <td valign="bottom">Musical Theatre</td>
              <td valign="middle" class="number">$400,199,798</td>
              <td valign="middle" class="number">18.5%</td>

              <th>2</th>
              <td valign="bottom">Musical Theatre</td>
              <td valign="middle" class="number">3,917,532</td>
              <td valign="middle" class="number">14.9%</td>
            </tr>
            <tr>
              <th>3</th>
              <td valign="bottom">Comedy</td>
              <td valign="middle" class="number">$124,742,437</td>
              <td valign="middle" class="number">5.8%</td>

              <th>3</th>
              <td valign="bottom">Festivals (Multi-Category)</td>
              <td valign="middle" class="number">2,577,932</td>
              <td valign="middle" class="number">9.8%</td>
            </tr>
            <tr>
              <th>4</th>
              <td valign="bottom">Festivals (Contemporary Music)</td>
              <td valign="middle" class="number">$102,015,922</td>
              <td valign="middle" class="number">4.7%</td>

              <th>4</th>
              <td valign="bottom">Comedy</td>
              <td valign="middle" class="number">2,458,198</td>
              <td valign="middle" class="number">9.4%</td>
            </tr>
            <tr>
              <th>5</th>
              <td valign="bottom">Classical Music</td>
              <td valign="middle" class="number">$79,456,707</td>
              <td valign="middle" class="number">3.7%</td>

              <th>5</th>
              <td valign="bottom">Children's/Family</td>
              <td valign="middle" class="number">1,650,955</td>
              <td valign="middle" class="number">6.3%</td>
            </tr>
            </tbody>
          </table>

          <h3>Top 3 Biggest Changes in Revenue by Category</h3>
          <table cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <th colspan="3">Biggest Increase</th>
              <th colspan="3">Biggest Decline</th>
            </tr>
            <tr>
              <th width="3%"></th>
              <th valign="top" width="22%">Category</th>
              <th valign="top">% change in revenue (from 2017)</th>

              <th width="3%"></th>
              <th valign="top" width="22%">Category</th>
              <th valign="top">% change in revenue (from 2017)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>1</th>
              <td valign="bottom">Special Events</td>
              <td valign="middle" class="number">337.9%</td>

              <th>1</th>
              <td valign="bottom">Circus and Physical Theatre</td>
              <td valign="middle" class="number">-79.9%</td>

            </tr>
            <tr>
              <th>2</th>
              <td valign="bottom">Comedy</td>
              <td valign="middle" class="number">72.5%</td>

              <th>2</th>
              <td valign="bottom">Musical Theatre</td>
              <td valign="middle" class="number">-4.0%</td>
            </tr>
            <tr>
              <th>3</th>
              <td valign="bottom">Contemporary Music</td>
              <td valign="middle" class="number">32.2%</td>

              <th>3</th>
              <td valign="bottom">-</td>
              <td valign="middle" class="number">-</td>
            </tr>
            </tbody>
          </table>

          <h3>Top 3 Biggest Changes in Attendance by Category</h3>

          <table cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <th colspan="3">Biggest Increase</th>
              <th colspan="3">Biggest Decline</th>
            </tr>

            <tr>
              <th width="3%"></th>
              <th valign="top" width="22%">Category</th>
              <th valign="top" class="number">% change in attendance (from 2016)</th>

              <th width="3%"></th>
              <th valign="top" width="22%">Category</th>
              <th valign="top" class="number">% change in attendance (from 2016)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>1</th>
              <td valign="bottom">Comedy</td>
              <td valign="middle" class="number">98.5%</td>

              <th>1</th>
              <td valign="bottom">Circus and Physical Theatre</td>
              <td valign="middle" class="number">-61.3%</td>

            </tr>
            <tr>
              <th>2</th>
              <td valign="bottom">Festivals (Multi-Category)</td>
              <td valign="middle" class="number">38.1%</td>

              <th>2</th>
              <td valign="bottom">Classical Music</td>
              <td valign="middle" class="number">-4.3%</td>

            </tr>
            <tr>
              <th>3</th>
              <td valign="bottom">Children's/Family</td>
              <td valign="middle" class="number">26.4%</td>

              <th>3</th>
              <td valign="bottom">Musical Theatre</td>
              <td valign="middle" class="number">-3.1%</td>
            </tr>
            </tbody>
          </table>
        </div>
      </figure>
    </section>

    <CategoryTrends></CategoryTrends>

    <CategoryMovement></CategoryMovement>
  </div>
</template>

<script>
/*eslint-disable */
import CategoryTrends from './2019/CategoryTrends'
import CategoryMovement from './2019/CategoryMovement'

export default {
  components: {
    CategoryTrends,
    CategoryMovement,
  },
  data () {
    return {
      activeYear: 2019,
      reports: [
        {
          year: 2019,
          highestRevenue: {
            cat: 'Contemporary Music',
            value: 835.54
          },
          highestAttendance: {
            cat: 'Contemporary Music',
            value: 8.29
          },
          biggestRevenueChange: {
            dir: 'up',
            cat: 'Circus and Physical Theatre',
            value: 102.7
          },
          biggestAttendanceChange: {
            dir: 'up',
            cat: 'Special Events',
            value: 152.9
          }
        },
        {
          year: 2020,
          highestRevenue: {
            cat: 'Contemporary Music',
            value: 309.20
          },
          highestAttendance: {
            cat: 'Contemporary Music',
            value: 2.87
          },
          biggestRevenueChange: {
            dir: 'down',
            cat: 'Ballet and Dance',
            value: 88.6
          },
          biggestAttendanceChange: {
            dir: 'down',
            cat: 'Comedy',
            value: 84.4
          }
        }
      ],
    }
  },
  computed: {
    activeReport () {
      const self = this

      for (let i = 0; i < self.reports.length; i++) {
        const report = self.reports[i]
        if (report.year === self.activeYear) {
          return report
        }
      }

      return false
    }
  },
}
</script>
